import { useState } from "react";
import toast from "react-hot-toast";
import { openLiteAssessmentReportPdf } from "../api/client";

export default function LiteReportButton({
  surveyToken,
  className = "btn-secondary",
  label = "View Lite Assessment Report",
}) {
  const [busy, setBusy] = useState(false);

  const onClick = async () => {
    if (!surveyToken) return;
    setBusy(true);
    try {
      await openLiteAssessmentReportPdf(surveyToken);
    } catch (e) {
      toast.error(e.message || "Could not open report");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button type="button" className={className} onClick={onClick} disabled={busy}>
      {busy ? "Opening report…" : label}
    </button>
  );
}
